import { render, staticRenderFns } from "./swMarkets.vue?vue&type=template&id=c89bc28c&scoped=true"
import script from "./swMarkets.vue?vue&type=script&lang=js"
export * from "./swMarkets.vue?vue&type=script&lang=js"
import style1 from "./swMarkets.vue?vue&type=style&index=1&id=c89bc28c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c89bc28c",
  null
  
)

export default component.exports